import React, { FC, useMemo } from "react";

import { Col } from "react-bootstrap";

import currency from "currency.js";

import type { Resale } from "@api/graphql";
import { DocumentSubmissionInfo } from "@components/grouped_resales/DocumentSubmissionInfo";
import { DownloadsButton } from "@components/grouped_resales/DownloadButton";
import { ResaleParticipantDetails } from "@components/grouped_resales/ResaleParticipantDetails";
import { getDownloadFiles } from "@util/index";
import { calculateTotalRoyaltyForResales } from "@util/resale";

interface ResalesAccordionHeaderProps {
  resales: Resale[];
  isExternalUser: boolean;
  resaleCount: number;
}

export const ResalesAccordionHeader: FC<ResalesAccordionHeaderProps> = ({ resales, isExternalUser, resaleCount }) => {
  const firstResale = resales[0];
  const files = getDownloadFiles(isExternalUser, firstResale.curated_doc_s3_location, firstResale.invoice_s3_location);

  const hasInternalRequestSource = useMemo(
    () => resales.some((resale) => resale.request_source === "internal_user_form_submit"),
    [resales],
  );

  return (
    <>
      <Col sm={2}>
        <ResaleParticipantDetails
          companyName={firstResale.vendor_company_name}
          reporter={isExternalUser && hasInternalRequestSource ? "Resale team" : firstResale.reporter_name}
          isExternalUser={isExternalUser}
        />
      </Col>
      <Col sm={3}>
        <DocumentSubmissionInfo
          batchDocS3Location={firstResale.batch_doc_s3_location}
          resaleCount={resaleCount}
          reportedOn={firstResale.reported_on}
          requestSource={firstResale.request_source}
        />
      </Col>
      <Col md={2}>
        <span className="b3 bold">{currency(calculateTotalRoyaltyForResales(resales)).format()}</span>
      </Col>
      <Col sm={2}>
        <DownloadsButton files={files} />
      </Col>
    </>
  );
};
